module.exports = __webpack_public_path__ + "96dcb418.webp";